import { getToday, oneYearBefore } from '@/utils/formatTime';
import moment from 'moment';

export const defaultValuesIRMarketEnvironment = {
  currency: '1',
  irIndex: 78,
  years: 7,
  swapTenors: [],
  startDate: '',
  endDate: '',
  runDates: [''],
};

export const defaultValuesDebtHedgeSchedule = {
  companyEntity: null,
  debts: '',
  trades: '',
  debtStartDate: '',
  debtEndDate: '',
  frequency: 'Quarterly',
  amortRate: 0,
  notionalCurrency: null,
  notionalAmount: 0,
  runDate: getToday(),
  hedgePercentage: '0.50,0.75',
  hedgeStartDate: oneYearBefore(),
  hedgeEndDate: getToday(),
};

export const defaultValuesPricingSummary = {
  currency: { value: '1', label: 'USD' },
  irIndex: { value: 78, label: 'LIBOR 3M' },
  runDate: '',
  frequency: { value: 'Quarterly', label: 'Quarterly' },
  notional: 100000000,
  fundingSpread: 500,
  normalVolAdjustment: 5,
  floorStrike: 1,
  cap: true,
  swap: true,
  swapFloor: true,
  capMode: false,
  capStrikesList: '4.5, 5, 5.5',
  capStrikesAtmBpsList: '50, 100, 150',
  zeroCostCollar: false,
  hedgePercentage: '0.75',
  cftt: false,
  amortRate: 0,
  dayCount: 360,
  enable_hedge_breakage: false,
  debt_and_hedge_enabled: false,
  debtType: 2,
  debtSpread: 150,
  debtFloor: 0,
  debtCoupon: 0,
  debtDayCount: undefined,
  debtSchedule: [],
  debtScheduleOverridden: false,
  graphGroups: {
    1: {
      effectiveDate: moment().endOf('year').format('YYYY-MM-DD'),
      maturityDate: moment().add(3, 'years').endOf('year').format('YYYY-MM-DD'),
      swapCharge: '',
      graph: true,
      breakage: [],
    },
  },
};

export const defaultValuesCashflowThroughTime = {
  dayCount: 360,
  companyEntity: null,
  debts: '',
  trades: '',
  runDate: '',
};

export const frequencyOptions = [
  { value: 'Annual', label: 'Annual' },
  { value: 'Semi-annual', label: 'Semi-Annual' },
  { value: 'Quarterly', label: 'Quarterly' },
  { value: 'Monthly', label: 'Monthly' },
];

export const DEBT_TYPE_FIXED = 1;
export const DEBT_TYPE_FLOAT = 2;

export const debtTypeOptions = [
  { value: DEBT_TYPE_FLOAT, label: 'Float' },
  { value: DEBT_TYPE_FIXED, label: 'Fixed' },
];

// Months per accrual period, keyed by frequency option value.
export const frequencyMonths: Record<string, number> = {
  Annual: 12,
  'Semi-annual': 6,
  Quarterly: 3,
  Monthly: 1,
};

export const SAVE_USER_WIDGET_DATA_MODAL_ID = 'save_user_widget_data_modal_id';
export const INFO_WIDGET_DATA_MODAL_ID = 'INFO_WIDGET_DATA_MODAL_ID';
